import { ORDER_ADD, ORDER_ERROR, ORDER_SUCCESS, ORDER_PARAMETERS,ORDER_RESTAPI } from "../actions/order";
import apiCall from "../../utils/api";
import Vue from "vue";
import { AUTH_LOGOUT } from "../actions/auth";
import axios from "axios";

const state = {status: "", OrderViewParameters: {OrderType: "", sales: 0, naics: "", range: "", state: "", zip: "" },
axiosData: {}, RESTAPI: ""
 };

const getters = {
  getOrderViewParameters: state => state.OrderViewParameters,
  getAxiosData: state => state.axiosData,
};

const actions = {
  [ORDER_ADD]: ({ commit, dispatch,rootGetters },parameters) => {
    console.log("**ORDER_ADD***");
    console.log(parameters);
    console.log(state.OrderViewParameters);

    // get the credentials from the auth module
    console.log(rootGetters);
    console.log(rootGetters.authCredentials);

    var p = state.OrderViewParameters
    console.log("**ORDER_ADD-- var p***");
    console.log(p);
    var URI = state.RESTAPI + "/api/Orders/Norm";
    const options = {
      headers: {'X-Token': rootGetters.authToken}
    };

    commit(ORDER_ADD);
    axios
      .post(URI, {naics: p.naics, range: p.range, state: p.state, zip: p.zip },options)
      .then(r => {
        console.log("**Axios Response-then***");
    console.log(r)

      commit(ORDER_SUCCESS,r.data);

      })
      .catch(err => {
        console.log("**Axios Response-catch***");
        commit(ORDER_ERROR);
        reject(err);
      });



  }
};

const mutations = {
  [ORDER_PARAMETERS]: (state,parameters) => {
    console.log("**ORDER_PARAMETERS-mutation***");
    console.log(parameters);
    state.status = "set-parameters";
    state.OrderViewParameters = {OrderType: parameters.OrderType, sales: parameters.sales,
       naics: parameters.naics, range: parameters.range, state: parameters.state,
       zip: parameters.zip }
  },
  [ORDER_ADD]: (state) => {
    console.log("**ORDER_ADD-mutation***");
    state.status = "loading";
    // state.axiosData = data;
  },
  [ORDER_SUCCESS]: (state, data) => {
    console.log("**ORDER_SUCCESS-mutation***");
    state.status = "success";
    state.axiosData = data;
  //  Vue.set(state, "profile", resp);
  },
  [ORDER_RESTAPI]: (state, api) => {
    console.log("**ORDER_RESTAPI-mutation***",api);
    state.RESTAPI = api;
  //  Vue.set(state, "profile", resp);
  },
    [ORDER_ERROR]: state => {
    state.status = "error";
    state.axiosData = {};
  },
  [AUTH_LOGOUT]: state => {
    state.profile = {};
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/order.js